import React, { memo, useEffect, useState } from "react";
import { Switch } from "antd";
// import css from "./index.less";
import Text from "./textElem";
import UlText from "./ulTextElem";
import { getDefaultComponentStyle } from "./utils/defaultStyles";

export default memo(
  ({
    data,
    getText,
    isStreaming,
    btnRequestHandle,
  }: {
    data: IMultiElementCombineMsg.ITextSwitchElem;
    getText: (text: IMultiElementCombineMsg.IText) => string;
    isStreaming: boolean;
    btnRequestHandle: ({
      url,
      elem,
      extra,
    }: IMultiElementCombineMsg.ISubmitParams) => void;
  }) => {
    const {
      id,
      type,
      left_content,
      right_content,
      disable,
      isSubItem,
      line_height = 22,
    } = data;
    const style = getDefaultComponentStyle(data) as any;

    if (line_height && line_height > 0) style.lineHeight = `${line_height}px`;
    const [switchChecked, setSwitchChecked] = useState(!!right_content.isOn);

    useEffect(() => {
      setSwitchChecked(!!right_content.isOn);
    }, [right_content.isOn]);

    const switchChange = (checked: boolean) => {
      const { action_url, extra = "" } = right_content;
      setSwitchChecked(checked);
      action_url &&
        btnRequestHandle({
          url: action_url,
          elem: { id, type, value: checked ? 1 : 0 },
          extra,
        });
    };

    return (
      <div
        className={`${"sscard-textSwitchBox"}`}
        // style={line_height > 0 ? { lineHeight: `${line_height}px` } : {}}
        style={style}
      >
        {!isSubItem ? (
          <Text
            data={{ content: left_content }}
            getText={getText}
            isStreaming={isStreaming}
          />
        ) : (
          <UlText
            data={{ content: left_content }}
            getText={getText}
            isStreaming={isStreaming}
            top={Math.round((line_height - 6) / 2)}
          />
        )}
        <div onClick={(e) => e?.stopPropagation()}>
          <Switch
            className={"switch"}
            checked={switchChecked}
            disabled={!!disable}
            onChange={switchChange}
          />
        </div>
      </div>
    );
  }
);
